import React from 'react'
import './input-check.scss'

const InputCheck = props => {
    const { label, setActive, active = false, error } = props

    return (
        <div className="a-check-input">
            <div className={"a-check-value-indicator " + (active ? 'active ' : '') + (error ? 'error ' : '')} onClick={() => setActive(!active)}>
                <i className="a-check-icon far fa-check"></i>
            </div>
            {label && <div className="a-check-label-container">
                {label}
            </div>}
        </div>
    )
}

export default InputCheck
